module.exports = "/assets/e041ff0b922fcf738500e21dcaa5c7a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/WP.png
// module id = 3087
// module chunks = 0